<script setup lang="ts">
import { dragscroll as vDragscroll } from 'vue-dragscroll'
import type { PlpCrossNavigationsLinksProps } from './PlpCrossNavigationsLinks.props'

const emit = defineEmits<{
  onLinkClick: [label: string]
}>()

const { breakpoint } = useProjectBreakpoint()
const isDesktop = breakpoint.greater('md')

const props = defineProps<PlpCrossNavigationsLinksProps>()

const CrossNavigationsLinksBlock = ref<HTMLElement>()
const linkScrollableDiv = ref<HTMLElement>()
const linkItem = ref<Element | ComponentPublicInstance | null>()
const route = useRoute()

onMounted(() => {
  if (
    linkItem.value &&
    linkScrollableDiv.value &&
    CrossNavigationsLinksBlock.value
  ) {
    const linkLabel = (linkItem.value as HTMLElement).children[0] as HTMLElement // NuxtLink Element

    const scrollX =
      linkLabel.offsetLeft -
      CrossNavigationsLinksBlock.value.offsetWidth / 2 +
      linkLabel.offsetWidth / 2

    nextTick(() => {
      requestAnimationFrame(() => {
        linkScrollableDiv.value!.scrollTo({
          left: scrollX,
          behavior: 'smooth',
          // You can change this to 'auto' for instant scrolling
        })
      })
    })
  }
})

const scrollHorizontally = (event: WheelEvent) => {
  if (event.deltaX !== 0) return
  event.preventDefault()
  if (linkScrollableDiv.value) {
    linkScrollableDiv.value.scrollBy({
      left: event.deltaY,
    })
  }
}

const checkPath = (linkPath?: string) => {
  const current = route.path.toLowerCase()
  return current === `${linkPath?.toLowerCase()}/`
}
</script>

<template>
  <div
    v-if="props.items && props.items.length"
    ref="CrossNavigationsLinksBlock"
    class="bg-background-secondary text-text-primary py-md positive-padding flex flex-row flex-wrap gap-4 md:gap-6"
  >
    <span v-if="props.label" class="text-medium-6 uppercase">
      {{ props.label }}:
    </span>
    <div
      ref="linkScrollableDiv"
      v-dragscroll.x="{ active: isDesktop }"
      class="scrollbar-hide -mx-sm px-sm md:-mx-md md:px-md flex items-center overflow-x-auto overflow-y-hidden lg:mx-0 lg:px-0"
      @wheel="scrollHorizontally"
    >
      <div
        v-for="(link, index) in props.items"
        :ref="el => (checkPath(link?.to) ? (linkItem = el) : null)"
        :key="index"
        class="text-light-6 mr-2 flex items-center gap-2 last:mr-0"
      >
        <h1 v-if="checkPath(link?.to)" class="text-medium-6 text-nowrap">
          {{ link.label }}
        </h1>
        <MoleculesLinkWrapper
          v-else
          :to="link?.to ? link?.to?.toLowerCase() : ''"
          class="whitespace-nowrap"
          anatomy="link"
          :underline-effect="'appear'"
          @click="emit('onLinkClick', link.label)"
        >
          <template #label>
            {{ link.label }}
          </template>
        </MoleculesLinkWrapper>
        <span v-if="index < props.items.length - 1">・</span>
      </div>
    </div>
  </div>
</template>
